<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },

    isExpanded: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    internalIsExpanded: false
  }),

  watch: {
    isExpanded: {
      immediate: true,
      handler() {
        this.internalIsExpanded = this.isExpanded
      }
    }
  },

  methods: {
    toggleState() {
      const isExpanded = !this.internalIsExpanded

      this.internalIsExpanded = isExpanded
      this.$emit('update:is-expanded', this.internalIsExpanded)

      if (this.internalIsExpanded) {
        this.$emit('expanded')
      }
    }
  }
}
</script>

<template>
  <div class="border border-gray-300 rounded">
    <div
      class="bg-gray-300 flex items-center group cursor-pointer hover:bg-gray-400"
      @click="toggleState"
    >
      <div>
        <button
          type="button"
          class="w-10 h-10 flex items-center justify-center hover:text-orange-mia group-hover:text-orange-mia focus:outline-none text-blue-500"
          @click="toggleState"
        >
          <mia-streamline-icon
            class="w-5 h-5 fill-current"
            :src="internalIsExpanded ? 'subtract' : 'add'"
          />
        </button>
      </div>
      <div class="flex items-center ml-1 py-2 font-bold">
        {{ title }}
      </div>
    </div>
    <div v-show="internalIsExpanded">
      <slot />
    </div>
  </div>
</template>
